import {
  CREATE_TICKET_CHECK,
  UPDATE_TICKET_CHECK,
  UNLOAD_TICKET_CHECK,
  FETCH_TICKET_CHECK_LIST,
  TICKET_CHECK_FETCHED_SUCCESS,
  TICKET_CHECK_FETCHED_FAILED,
} from '../constants/actionTypes';

const initialState = {
  checks: [],
  message: '',
  pager: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CREATE_TICKET_CHECK:
    case UPDATE_TICKET_CHECK:
      return {
        ...state,
        message: action.payload.msg,
      };

    case UNLOAD_TICKET_CHECK:
      return initialState;

    case TICKET_CHECK_FETCHED_SUCCESS:
      return {
        ...state,
        checks: action.payload.checks,
        pager: action.payload.pager,
      };

    case TICKET_CHECK_FETCHED_FAILED:
    case FETCH_TICKET_CHECK_LIST:
      return state;

    default:
      return state;
  }
};
